import { render, staticRenderFns } from "./facility-part-type.vue?vue&type=template&id=068fab4e&scoped=true&lang=html&"
import script from "./facility-part-type.vue?vue&type=script&lang=js&"
export * from "./facility-part-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068fab4e",
  null
  
)

export default component.exports